import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { BjdItem } from '@/service/common/commonQueries';

interface RegionType {
  areaInfo: BjdItem;
  isHydrated: Boolean;
  setIsHydrated: (state: Boolean) => void;
  setAreaInfo: (regionCode: BjdItem) => void;
}

export const useRegionStore = create<RegionType>()(
  persist(
    (set, get) => ({
      areaInfo: {
        bjdCd: '',
        sidoNm: '',
        sidoBasicNm: '',
        gugunNm: '',
        bjdNm: '',
        bjdLevel: '',
        xpos: '',
        ypos: '',
      },
      isHydrated: false,
      setIsHydrated: (state) => set({ isHydrated: state }),
      setAreaInfo: (areaInfo) => set((state) => ({ areaInfo })),
    }),
    {
      name: 'AreaInfo',
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setIsHydrated(true);
        }
      },
    },
  ),
);

export const useRegionTitle = useRegionStore.subscribe((state) => state.areaInfo);
